module.exports = __webpack_public_path__ + "img/mb4.ff7945cd.jpg";